module.exports = __webpack_public_path__ + "static/media/icon-youtube.c510249b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/icon-youtube.svg
// module id = 598
// module chunks = 0